@import '../scss/base';

// Variant
:host(.default) {
  background-color: css-var(comp-nav-top-background-color-default);
}

:host(.default[placement='top']) {
  border-bottom: css-var(comp-nav-top-bottom-border);
}

:host(.subtle) {
  background-color: css-var(comp-nav-top-background-color-subtle);
}

:host([full-width='true']) {
  max-width: 100%;
}

:host {
  color: css-var(comp-nav-top-foreground-color-moderate);
  z-index: css-var(style-z-index-2400);
  position: fixed;
  box-sizing: border-box;
  height: max-content;
  width: 100%;
  max-width: 630px;

  // Ensure it's always centered, doesn't matter where in the flow it is.
  left: 50%;
  transform: translateX(-50%);

  slot:first-child {
    display: flex;
    align-items: center;
  }
}

// Placement
:host([placement='top']) {
  color: css-var(color-grey-600);
  top: 0;

  slot:first-child {
    justify-content: space-between;
    padding: css-var(comp-nav-top-mixed-padding);
  }

  ::slotted(h3) {
    flex: 1 1 0;
    text-align: center;
    text-overflow: ellipsis;
  }
}

:host([placement='bottom']) {
  background-color: css-var(comp-nav-bottom-background-color);
  box-shadow: css-var(comp-nav-bottom-shadow);
  bottom: 0;

  slot:first-child {
    justify-content: space-around;
    gap: css-var(comp-nav-bottom-content-gap);
    padding: css-var(comp-nav-bottom-padding);
  }
}

:host([placement='left']) {
  background-color: css-var(comp-nav-left-background-color);
  left: 0;
  top: 0;
  bottom: 0;
  width: auto;
  height: 100%;
  transform: none;

  slot:first-child {
    flex-direction: column;
    justify-content: start;
    gap: css-var(comp-stack-gap-wide);
    padding: css-var(comp-nav-left-padding);
  }
}

:host(.no-inline-padding) {
  slot:first-child {
    padding-inline: 0;
  }
}
